const API_BASE_URL = 'https://risk-api-backend.onrender.com';
export default API_BASE_URL;